import {Component} from '@angular/core';

@Component({
    selector: 'blitz-basic-script-progress-bar',
    templateUrl: 'progress-bar.html'
    //styleUrls: ['blitz-basic-script.scss']
})
export class ProgressBarComponent {
    constructor() {

    }
}
